import { useTheme } from '@emotion/react';
import { ReactNode } from 'react';

type ILabelEventProps = {
  text?: ReactNode;
  description?: string;
};

export function LabelEvent({ text, description }: ILabelEventProps) {
  const theme = useTheme();
  return (
    <div
      title={description}
      css={{
        display: 'block',
        background: theme.colors.red,
        borderRadius: 2,
        fontFamily: 'Golos',
        fontWeight: 500,
        fontSize: 12,
        color: theme.colors.white,
        padding: '4px 10px',
      }}
    >
      {text}
    </div>
  );
}
